export class PolicyControlModel {
    cpcCaseTypeId: string;
    cpcCheckMethodId: string;
    cpcOrganizationunit: {};
    cpcOrganizationunitId: string;
}